$(function () {
  $('.owl-carousel-brands').owlCarousel({
    loop: true,
    margin: 30,
    lazyLoad: true,
    responsiveClass: true,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
      0: {
        items: 2,
        nav: true,
        dots: false,
      },
      600: {
        items: 4,
        nav: true,
      },
      1000: {
        items: 4,
        nav: true,
        autoplay: false,
        loop: true,
      },
    },
  });
});
